export class StatusView {
  constructor(container, { onResume, onRestart, onMainMenu }) {
    this.container = container;
    this.onResume = onResume;
    this.onRestart = onRestart;
    this.onMainMenu = onMainMenu;

    this.pauseModalEl = null;
    this.toastContainer = null;
    this.toastTimer = null;

    this.init();
  }

  init() {
    // 1. Toast Notification Container (Top Center)
    this.toastContainer = document.createElement('div');
    this.toastContainer.style.position = 'absolute';
    this.toastContainer.style.top = '20px';
    this.toastContainer.style.left = '50%';
    this.toastContainer.style.transform = 'translateX(-50%)';
    this.toastContainer.style.zIndex = '50';
    this.toastContainer.style.pointerEvents = 'none';
    this.container.appendChild(this.toastContainer);

    // 2. Pause Modal Backdrop & Card
    this.pauseModalEl = document.createElement('div');
    this.pauseModalEl.className = 'ui-view pause-view hidden modal-backdrop';

    const card = document.createElement('div');
    card.className = 'card-panel';
    card.style.maxWidth = '360px';
    card.style.width = '100%';
    card.style.textAlign = 'center';

    const title = document.createElement('h2');
    title.className = 'text-heading';
    title.textContent = 'PAUSED';
    title.style.marginBottom = '20px';
    card.appendChild(title);

    const resumeBtn = document.createElement('button');
    resumeBtn.className = 'btn-primary';
    resumeBtn.style.width = '100%';
    resumeBtn.style.marginBottom = '12px';
    resumeBtn.textContent = '▶ Resume';
    resumeBtn.onclick = () => this.onResume();
    card.appendChild(resumeBtn);

    const restartBtn = document.createElement('button');
    restartBtn.className = 'btn-secondary';
    restartBtn.style.width = '100%';
    restartBtn.style.marginBottom = '12px';
    restartBtn.textContent = 'Restart Run';
    restartBtn.onclick = () => this.onRestart();
    card.appendChild(restartBtn);

    const menuBtn = document.createElement('button');
    menuBtn.className = 'btn-text';
    menuBtn.style.width = '100%';
    menuBtn.textContent = 'Main Menu';
    menuBtn.onclick = () => this.onMainMenu();
    card.appendChild(menuBtn);

    this.pauseModalEl.appendChild(card);
    this.container.appendChild(this.pauseModalEl);
  }

  showToast(message, type = 'info', duration = 3000) {
    clearTimeout(this.toastTimer);
    this.toastContainer.innerHTML = '';

    const toast = document.createElement('div');
    toast.className = 'card-panel';
    toast.style.padding = '8px 18px';
    toast.style.borderRadius = 'var(--radius-pill)';
    toast.style.fontSize = '0.9rem';
    toast.style.fontWeight = '600';
    toast.style.display = 'inline-flex';
    toast.style.alignItems = 'center';
    toast.style.gap = '8px';
    toast.style.boxShadow = '0 8px 24px rgba(0, 0, 0, 0.5)';
    toast.style.border = '1px solid var(--color-border)';

    if (type === 'success') {
      toast.style.borderColor = 'var(--color-success)';
      toast.style.color = 'var(--color-success)';
    } else if (type === 'error') {
      toast.style.borderColor = 'var(--color-danger)';
      toast.style.color = 'var(--color-danger)';
    } else {
      toast.style.color = 'var(--color-primary)';
    }

    toast.textContent = message;
    this.toastContainer.appendChild(toast);

    this.toastTimer = setTimeout(() => {
      this.toastContainer.innerHTML = '';
    }, duration);
  }

  showPause() {
    this.pauseModalEl.classList.remove('hidden');
  }

  hidePause() {
    this.pauseModalEl.classList.add('hidden');
  }
}
